const onFailure = (error) => ({
  message: 'Categoria de produto já cadastrada!',
  type: 'warning',
});

export default onFailure;
